import { GroupsCard } from './GroupsCard';
export default GroupsCard;
